export const UserGuideApi = Symbol.for('UserGuideApi');
